import { useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { BonusCardRequestComponent } from "@/components/Account/RequestBonusCard/requestBonusCard.component";
import { RequestBonusCardWrapper } from "@/components/Account/RequestBonusCard/requestBonusCard.wrapper";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as AddressBookModule from "@/redux/modules/api/data/addressbook/addressbook.module";
import { getAddresses } from "@/redux/modules/api/data/addressbook/addressbook.selectors";
import { getCart } from "@/redux/modules/api/data/cart/cart.selectors";
import {
    getBonusCardStatus,
    getCustomer
} from "@/redux/modules/api/data/customer/customer.selectors";
import { getPaymentAddress } from "@/utils/address/address";
import { BonusCardStatus } from "@/utils/enums";

type RequestBonusCardProps = {
    requesttitle: string;
    requesttext: string;
    requestbuttontext: string;
    thankstitle: string;
    thankstext: string;
    onroutetitle: string;
    onroutetext: string;
};

const RequestBonusCard = ({
    requesttitle,
    requesttext,
    requestbuttontext,
    thankstitle,
    thankstext,
    onroutetitle,
    onroutetext
}: RequestBonusCardProps) => {
    const dispatch = useThunkDispatch();

    const customer = useSelector(getCustomer, shallowEqual);
    const bonusCardStatus = useSelector(getBonusCardStatus, shallowEqual);
    const addresses = useSelector(getAddresses, shallowEqual);
    const shoppingCart = useSelector(getCart, shallowEqual);

    const getAddress = () => getPaymentAddress(addresses, shoppingCart);

    const loadAddressBook = () => dispatch(AddressBookModule.load());

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        loadAddressBook();
    }, []);

    return (
        <RequestBonusCardWrapper
            customer={{
                firstName: customer?.firstName,
                lastName: customer?.lastName,
                email: customer?.email,
                dateOfBirth: customer?.dateOfBirth ?? undefined,
                favouriteStoreId: customer?.favouriteStoreId ?? undefined
            }}
            bonusCardStatus={bonusCardStatus ?? BonusCardStatus.NoCard}
            address={getAddress()}
        >
            {({ openModal, bonusCardStatus }) => (
                <div className="mb-5">
                    <BonusCardRequestComponent
                        bonusCardStatus={bonusCardStatus}
                        requestTitle={requesttitle}
                        requestText={requesttext}
                        requestButtonText={requestbuttontext}
                        thanksTitle={thankstitle}
                        thanksText={thankstext}
                        onRouteTitle={onroutetitle}
                        onRouteText={onroutetext}
                        openModal={openModal}
                    />
                </div>
            )}
        </RequestBonusCardWrapper>
    );
};

export { RequestBonusCard };
